import TransmitConstants from './constants';
import * as log from './utils/log';
import BaseTransportProvider from './components/BaseTransportProvider';
var env = '';
var getQAEndpoints = function (internal, server, secureaccess) {
    internal && (env = TransmitConstants.endpoints.qa_proxy);
    server && (env = TransmitConstants.endpoints.securelink_qa);
    secureaccess && (env = TransmitConstants.endpoints.qa);
    !internal &&
        !server &&
        !secureaccess &&
        (env = TransmitConstants.endpoints.qaapigee);
    return env;
};
var getStageEndPoints = function (internal, server, secureaccess) {
    internal && (env = TransmitConstants.endpoints.stg_proxy);
    server && (env = TransmitConstants.endpoints.securelink_stg);
    secureaccess && (env = TransmitConstants.endpoints.stg);
    !internal &&
        !server &&
        !secureaccess &&
        (env = TransmitConstants.endpoints.stgapigee);
    return env;
};
var getProdEndPoints = function (internal, server, secureaccess) {
    internal && (env = TransmitConstants.endpoints.prod_proxy);
    server && (env = TransmitConstants.endpoints.securelink);
    secureaccess && (env = TransmitConstants.endpoints.prod);
    !internal &&
        !server &&
        !secureaccess &&
        (env = TransmitConstants.endpoints.prodapigee);
    return env;
};
var getEnv = function (host, server, isLoggingEnabled, secureaccess, internal) {
    if (host === 'development') {
        env = TransmitConstants.endpoints.devapigee;
    }
    else if (host === 'qa') {
        env = getQAEndpoints(internal, server, secureaccess);
    }
    else if (host === 'staging') {
        env = getStageEndPoints(internal, server, secureaccess);
    }
    else if (host === 'production') {
        env = getProdEndPoints(internal, server, secureaccess);
    }
    return env;
};
var getServerEndPoint = function (environment) {
    return 'https://'.concat(environment);
};
var configureSDK = function (transmitsdk, appData, crypto, secureaccess, internal, params, data) {
    var host = params.appEnv;
    var serverUrl = getServerEndPoint(getEnv(host, appData.serverUrl, data.isLoggingEnabled, secureaccess, internal));
    var applicationId = appData.applicationId;
    var connectionSettings = {};
    if (!crypto) {
        connectionSettings = window.com.ts.mobile.sdk.SDKConnectionSettings.create(serverUrl, applicationId);
    }
    else {
        connectionSettings =
            window.com.ts.mobile.sdk.SDKConnectionSettings.createWithCryptoMode(serverUrl, applicationId, '', '', window.com.ts.mobile.sdk.ConnectionCryptoMode.Full);
    }
    data.OAuth2 === false &&
        transmitsdk.setTransportProvider(new BaseTransportProvider());
    transmitsdk.setLogLevel(window.com.ts.mobile.sdk.LogLevel.Off);
    transmitsdk.setConnectionSettings(connectionSettings);
    transmitsdk.setEnabledCollectors([
        window.com.ts.mobile.sdk.CollectorType.DeviceDetails
    ]);
};
var logoutSession = function (transmitsdk, isLoggingEnabled) {
    return new Promise(function (resolve, reject) {
        transmitsdk
            .logout()
            .then(function (response) {
            isLoggingEnabled &&
                log.info('onSdkLogoutSuccess', 'Primary active session has ended. Previous user logged out.', 'transmit');
            resolve(response);
        })
            .catch(function (error) {
            if (error.getData) {
                if (error.getErrorCode() !== TransmitConstants.errorCodes.noLoggedInUser) {
                    isLoggingEnabled &&
                        log.error(''.concat(error.getErrorCode(), ': ', error.getMessage()), error.getData());
                }
            }
            else {
                isLoggingEnabled && log.error('onSdkLogoutFailure', error);
            }
            reject(error);
        });
    });
};
var initializeSDK = function (transmitsdk, isLoggingEnabled) {
    return new Promise(function (resolve, reject) {
        transmitsdk
            .initialize()
            .then(function (response) {
            isLoggingEnabled &&
                log.info('onSdkInitializeSuccess', transmitsdk, 'transmit');
            resolve(response);
        })
            .catch(function (error) {
            if (error.getData) {
                isLoggingEnabled &&
                    log.error(''.concat('onSdkInitializeFailure::Error Code: ', error.getErrorCode(), ': ', error.getMessage()), error.getData());
            }
            else {
                isLoggingEnabled && log.error('onSdkInitializeFailure', error);
            }
            reject(error);
        });
    });
};
export { configureSDK, initializeSDK, logoutSession };
